/**
 * Support Domain Constants
 */

export const DEFAULT_PAGE_SIZE = 25

export const DEFAULT_SUPPORT_SORT = {
  sortBy: 'createdAt' as const,
  sortOrder: 'desc' as const,
}

export const SUPPORT_ENDPOINTS = {
  BASE: '/api/support-tickets',
} as const

export const TICKET_STATUS = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  WAITING_ON_REPORTER: 'waiting_on_reporter',
  RESOLVED: 'resolved',
  CLOSED: 'closed',
} as const

export const TICKET_CATEGORY = {
  ORDER_ISSUE: 'order_issue',
  DELIVERY_ISSUE: 'delivery_issue',
  PAYMENT_ISSUE: 'payment_issue',
  ACCOUNT_ISSUE: 'account_issue',
  PLATFORM_BUG: 'platform_bug',
  FEATURE_REQUEST: 'feature_request',
  GENERAL: 'general',
  OTHER: 'other',
} as const

export const TICKET_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  URGENT: 'urgent',
} as const

export const TICKET_CHANNEL = {
  CUSTOMER_TO_SPCC: 'customer_to_spcc',
  SPCC_TO_525K: 'spcc_to_525k',
} as const

export const CUSTOMER_CATEGORIES = [
  TICKET_CATEGORY.ORDER_ISSUE,
  TICKET_CATEGORY.DELIVERY_ISSUE,
  TICKET_CATEGORY.PAYMENT_ISSUE,
  TICKET_CATEGORY.ACCOUNT_ISSUE,
  TICKET_CATEGORY.GENERAL,
  TICKET_CATEGORY.OTHER,
] as const

export const INTERNAL_CATEGORIES = [
  TICKET_CATEGORY.PLATFORM_BUG,
  TICKET_CATEGORY.FEATURE_REQUEST,
  TICKET_CATEGORY.GENERAL,
  TICKET_CATEGORY.OTHER,
] as const
